// этот хелпер выводит 2 нолика в таимере при любых обстоятельствах

export const padTime = (time: number) => time.toString().padStart(2, '0')